import { render } from "./GroupsList.vue?vue&type=template&id=01e451fd&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"

import "./GroupsList.vue?vue&type=style&index=0&id=01e451fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01e451fd"]])

export default __exports__